import { Injectable, OnDestroy } from '@angular/core'
import { EStorageType } from '@pichincha/angular-sdk/auth'
import { storage } from '@pichincha/angular-sdk/storage'
import { BehaviorSubject, Observable } from 'rxjs'
import { environment } from '../../../environments/environment'
import { NavigationEnd, Router } from '@angular/router'
import { filter } from 'rxjs/operators'
import { EVENT_NAMES } from '../../utils/events'

const defaultSteps = [
  'Valida tu identidad',
  'Completa tu información',
  'Confirma tu cuenta',
  '¡Ya tienes tu cuenta!',
]

const updatedClientSteps = [
  'Completa tu información',
  'Confirma tu cuenta',
  '¡Ya tienes tu cuenta!',
]

const defaultFlexibleSteps = [
  'Valida tu identidad',
  'Empieza a ahorrar',
  'Completa tu información',
  'Confirma tu cuenta',
  '¡Ya tienes tu cuenta!',
]

const updatedFlexibleSteps = [
  'Empieza a ahorrar',
  'Completa tu información',
  'Confirma tu cuenta',
  '¡Ya tienes tu cuenta!',
]

@Injectable({
  providedIn: 'root',
})
export class StepperService implements OnDestroy {
  storage = storage({
    storageType: EStorageType.SESSION,
    secretKey: environment.storage.key,
  })

  private steps$ = new BehaviorSubject<string[]>(defaultSteps)
  private actualStep$ = new BehaviorSubject<number>(0)
  private routerSubscription: any

  constructor(private router: Router) {
    this.routerSubscription = this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe(event => {
        this.onRouterChange(event)
      })
  }

  ngOnDestroy(): void {
    this.routerSubscription.unsubscribe()
  }

  public onRouterChange(event: any) {
    const { url } = event as { url: string }
    const isUpdated = this.storage.get(EVENT_NAMES.loginOnAuthenticate).data?.jwt ? true : false
    const [_, _flow, _process, _clientType, step] = url.split('/')
    if (!step) return
    if (isUpdated) this.setUpdatedClientSteps(step)
    else this.setProspectSteps(step)
  }

  public getSteps(): Observable<string[]> {
    return this.steps$
  }

  public getActualStep(): Observable<number> {
    return this.actualStep$
  }

  public getFlow() {
    const flow = this.router.url.split('/')[1]
    return flow || undefined
  }

  public setUpdatedClientSteps(step: string) {
    const flow = this.getFlow()
    flow === 'flexible'
      ? this.steps$.next(updatedFlexibleSteps)
      : this.steps$.next(updatedClientSteps)
    const urlToStepUpdatedClientMapper =
      flow === 'flexible'
        ? {
            foto: 0,
            validacion: 1,
            simulacion: 1,
            firc: 2,
            fiscal: 2,
            otp: 3,
            exito: 4,
          }
        : {
            foto: 0,
            validacion: 1,
            firc: 1,
            fiscal: 1,
            otp: 2,
            exito: 3,
          }
    this.actualStep$.next(
      urlToStepUpdatedClientMapper[step as keyof typeof urlToStepUpdatedClientMapper] || 0
    )
  }

  public setProspectSteps(step: string) {
    const flow = this.getFlow()
    flow === 'flexible' ? this.steps$.next(defaultFlexibleSteps) : this.steps$.next(defaultSteps)
    const dontFlexible =  flow === 'migrante' 
      ? {
          foto: 1,
          validacion: 1,
          firc: 2,
          seguros: 2,
          fiscal: 2,
          tarjeta: 2,
          otp: 3,
          exito: 4,
        }
      : {
        foto: 1,
        validacion: 1,
        firc: 2,
        seguros: 2,
        fiscal: 2,
        otp: 3,
        exito: 4,
      }
    const urlToStepProspectMapper =
      flow === 'flexible'
        ? {
            foto: 1,
            validacion: 1,
            simulacion: 2,
            firc: 3,
            fiscal: 3,
            otp: 4,
            exito: 5,
          }
        : dontFlexible
    this.actualStep$.next(
      urlToStepProspectMapper[step as keyof typeof urlToStepProspectMapper] || 0
    )
  }
}
